<template>
  <Teleport to="body">
    <div v-if="sessionNeedsRecovery" class="session-recovery-overlay" role="alertdialog" aria-modal="true" aria-labelledby="session-recovery-title">
      <div class="session-recovery-dialog">
        <h2 id="session-recovery-title">{{ _('Your session has expired. Please log in again.') }}</h2>
        <button type="button" class="btn btn-success btn-lg" :disabled="isRecovering" v-on:click="signInAgain">
          <i class="fa fa-spinner fa-spin" v-if="isRecovering"></i>
          <template v-else>{{ _('Sign in again') }}</template>
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { recoverExpiredSession } from '~/lib/sessionRecovery'

export default {
  data () {
    return {
      isRecovering: false
    }
  },
  computed: {
    sessionNeedsRecovery () {
      return this.$store.state.sessionNeedsRecovery
    }
  },
  methods: {
    async signInAgain () {
      if (this.isRecovering) {
        return
      }
      this.isRecovering = true
      await recoverExpiredSession(this.$store)
    }
  }
}
</script>

<style scoped>
.session-recovery-overlay {
  position: fixed;
  inset: 0;
  z-index: 200000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.65);
}
.session-recovery-dialog {
  width: 100%;
  max-width: 420px;
  padding: 30px;
  text-align: center;
  background: #fff;
  border-radius: 2px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}
.session-recovery-dialog h2 {
  margin: 0 0 24px;
  color: #507C97;
  font-size: 22px;
  line-height: 1.35;
}
</style>
